import { render, staticRenderFns } from "./ModalInvoiceFrame.vue?vue&type=template&id=401c4967&scoped=true&"
import script from "./ModalInvoiceFrame.vue?vue&type=script&lang=js&"
export * from "./ModalInvoiceFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalInvoiceFrame.vue?vue&type=style&index=0&id=401c4967&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c4967",
  null
  
)

export default component.exports